import React from 'react';
import { Navigate } from 'react-router-dom';

// Authenticate off the same source the API client uses — the localStorage
// `token` (which the sliding-session interceptor keeps refreshed). The cookie
// was an unreliable signal: its Expires is derived from an env var that CRA
// doesn't expose to the browser, so it serialized to `Expires=Invalid Date`
// and some browsers dropped the cookie, bouncing valid sessions to /login.
const AuthGuard = ({ children }) => {
    const isAuthenticated = () => !!localStorage.getItem('token');

    return isAuthenticated() ? children : <Navigate to="/login" replace />;
};

export default AuthGuard;
